var path = '/components/components/al-pdf-viewer/component.tpl.html';
var html = "<div class=\"pdf-viewer\">\n    <div class=\"pdf-action-bar\">\n        <a href ng-click=\"vm.prevPage()\" class=\"arrow\" ng-class=\"{disabled: vm.currentPdfPage === 1}\"><i class=\"fal fa-arrow-left\"></i></a>\n        <span class=\"page-counter\">Page {{vm.currentPdfPage}}/{{vm.pdfDocument.numPages}}</span>\n        <a href ng-click=\"vm.nextPage()\" class=\"arrow\" ng-class=\"{disabled: vm.currentPdfPage === vm.pdfDocument.numPages}\"><i class=\"fal fa-arrow-right\"></i></a>\n    </div>\n    <canvas id=\"al_pdf_viewer_canvas\"></canvas>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/components/al-pdf-viewer/component.tpl.html
// module id = 1959
// module chunks = 1